import {FormActiveMark} from '../../../../../../component/form-active-mark/form-active-mark';
import {Text} from '../../../../../../component/text/text';
import {Locale} from '../../../../../../provider/locale/locale';
import * as styles from '../reviews-filter.scss';

type PropsType = {
    stringKey: Parameters<typeof Locale>[0]['stringKey'];
    isMarkVisible: boolean;
};

export function ReviewsFilterSectionLabel(props: PropsType): JSX.Element {
    const {stringKey, isMarkVisible} = props;

    return (
        <div className={styles.ReviewsFilter_sectionHeader}>
            <Text bolder>
                <Locale stringKey={stringKey} />
            </Text>
            <FormActiveMark className={styles.ReviewsFilter_sectionMark} isVisible={isMarkVisible} />
        </div>
    );
}
